import React from 'react';

interface LoadingWhaleProps {
  message?: string;
  size?: 'small' | 'medium' | 'large';
}

const LoadingWhale: React.FC<LoadingWhaleProps> = ({
  message = 'Loading...',
  size = 'large'
}) => {
  const sizeClasses = {
    small: 'text-5xl',
    medium: 'text-7xl',
    large: 'text-9xl',
  };

  return (
    <div className="flex flex-col items-center justify-center py-12">
      {/* Backflipping Whale */}
      <div className={`${sizeClasses[size]} mb-4 whale-backflip`}>
        {'\u{1F433}'}
      </div>

      {/* Splash effect */}
      <div className="flex gap-2 mb-4">
        <span className="text-2xl splash-drop" style={{ animationDelay: '0.3s' }}>{'\u{1F4A7}'}</span>
        <span className="text-3xl splash-drop" style={{ animationDelay: '0.4s' }}>{'\u{1F4A6}'}</span>
        <span className="text-2xl splash-drop" style={{ animationDelay: '0.5s' }}>{'\u{1F4A7}'}</span>
      </div>

      {/* Message */}
      <p className="text-xl text-gray-600 dark:text-gray-300 font-medium">{message}</p>

      {/* Backflip animation styles */}
      <style>{`
        .whale-backflip {
          animation: whaleBackflip 1.5s ease-in-out infinite;
          transform-origin: center center;
        }

        @keyframes whaleBackflip {
          0% {
            transform: translateY(0) rotate(0deg) scale(1);
          }
          15% {
            transform: translateY(-20px) rotate(0deg) scale(1.05);
          }
          30% {
            transform: translateY(-80px) rotate(180deg) scale(1.1);
          }
          50% {
            transform: translateY(-100px) rotate(360deg) scale(1.1);
          }
          70% {
            transform: translateY(-60px) rotate(360deg) scale(1.05);
          }
          85% {
            transform: translateY(-20px) rotate(360deg) scale(1);
          }
          100% {
            transform: translateY(0) rotate(360deg) scale(1);
          }
        }

        .splash-drop {
          animation: splashDrop 1.5s ease-out infinite;
          opacity: 0;
        }

        @keyframes splashDrop {
          0%, 60% {
            opacity: 0;
            transform: translateY(0) scale(0.5);
          }
          70% {
            opacity: 1;
            transform: translateY(-10px) scale(1.2);
          }
          100% {
            opacity: 0;
            transform: translateY(20px) scale(0.8);
          }
        }
      `}</style>
    </div>
  );
};

export default LoadingWhale;
